import { HTMLAttributes } from 'react'

interface LogoProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  variant?: 'full' | 'icon'
  showText?: boolean
  white?: boolean
}

export function Logo({
  size = 'md',
  variant = 'full',
  showText = true,
  white = false,
  className = '',
  ...props
}: LogoProps) {
  const sizeStyles = {
    sm: 'w-10 h-10',
    md: 'w-16 h-16',
    lg: 'w-24 h-24',
    xl: 'w-32 h-32',
  }

  const textSizeStyles = {
    sm: 'text-sm',
    md: 'text-lg',
    lg: 'text-2xl',
    xl: 'text-4xl',
  }

  return (
    <div className={`flex items-center gap-3 ${className}`} {...props}>
      {/* Logo Icon - ใช้ SVG จาก Figma */}
      <div className={`${sizeStyles[size]} relative flex-shrink-0`}>
        <img
          src="/assets/logo-icon.svg"
          alt="SENOVATE AI Logo"
          className="w-full h-full object-contain"
        />
      </div>

      {/* Logo Text */}
      {variant === 'full' && showText && (
        <div className="flex flex-col">
          <span className={`${textSizeStyles[size]} font-bold ${white ? 'text-white' : 'text-primary-800'} leading-tight`}>
            SENOVATE AI
          </span>
          {size !== 'sm' && (
            <span className={`text-xs ${white ? 'text-white/80' : 'text-text-tertiary'}`}>
              ระบบจัดการฟาร์มโคเนื้อ
            </span>
          )}
        </div>
      )}
    </div>
  )
}

export default Logo
